import i18next from 'i18next';
import isEmpty from 'lodash/isEmpty';

import { bulkTemplateStatus } from 'common/api/templates';
import showToast from 'common/utils/showToast';

import {
    BULK_UPDATE_ITEMS,
    BULK_UPDATE_ITEMS_FAILURE,
    BULK_UPDATE_ITEMS_SUCCESS,
} from '../actionTypes';
import { templatesActions } from '../reducer';

import filterTemplates from './filterTemplates';

export default (ids, value, filterData, callback) => (dispatch) => {
    dispatch(templatesActions[BULK_UPDATE_ITEMS]());

    const newValues = {
        status: value,
        templates: ids,
    };

    bulkTemplateStatus(newValues)
        .then(() => {
            dispatch(templatesActions[BULK_UPDATE_ITEMS_SUCCESS]());
            if (!isEmpty(filterData)) dispatch(filterTemplates(filterData));
            if (value === 'deleted')
                showToast({ body: i18next.t('It was successfully removed') });
            if (value === 'archived')
                showToast({ body: i18next.t('It was successfully archived') });
            if (value === 'active')
                showToast({
                    body: i18next.t('It was successfully unarchived'),
                });
            if (callback) callback();
        })
        .catch((error) =>
            dispatch(
                templatesActions[BULK_UPDATE_ITEMS_FAILURE](
                    error?.response?.data?.errors,
                ),
            ),
        );
};
